import React from "react";
import { Box, Skeleton, useTheme } from "@mui/material";
import {
  FOOTER_HEIGHT,
  MAX_ROWS_PER_SESSION,
  ROW_GAP,
  ROW_HEIGHT,
  SESSION_HEADER_HEIGHT,
} from "./earningsCalendarSelection";

// Mirrors the real week grid's geometry — two-line day header, then a session
// pair of fixed slots, then the footer — from the same constants, so nothing
// shifts when the data lands.

const DAYS = 5;

const CalendarSkeleton: React.FC = () => {
  const theme = useTheme();
  const skeletonBg =
    theme.palette.mode === "dark"
      ? "rgba(255,255,255,0.09)"
      : "rgba(0,0,0,0.09)";

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "minmax(0, 1fr)",
          md: "repeat(2, minmax(0, 1fr))",
          lg: "repeat(3, minmax(0, 1fr))",
          xl: `repeat(${DAYS}, minmax(0, 1fr))`,
        },
        gap: { xs: 2.5, md: 3 },
        alignItems: "start",
      }}
    >
      {Array.from({ length: DAYS }).map((_, day) => (
        <Box
          key={day}
          sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}
        >
          <Box sx={{ mb: 1.25, px: 0.25, pb: 0.75 }}>
            <Skeleton
              variant="rounded"
              height={18}
              width="55%"
              sx={{ borderRadius: 1, bgcolor: skeletonBg }}
            />
            <Skeleton
              variant="rounded"
              height={12}
              width="30%"
              sx={{ borderRadius: 0.5, bgcolor: skeletonBg, mt: 0.5 }}
            />
          </Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
              gap: 1,
            }}
          >
            {[0, 1].map((session) => (
              <Box
                key={session}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: `${ROW_GAP}px`,
                  minWidth: 0,
                }}
              >
                <Skeleton
                  variant="rounded"
                  height={10}
                  width="70%"
                  sx={{
                    borderRadius: 0.5,
                    bgcolor: skeletonBg,
                    my: `${(SESSION_HEADER_HEIGHT - 10) / 2}px`,
                  }}
                />
                {Array.from({ length: MAX_ROWS_PER_SESSION }).map((__, row) => (
                  <Skeleton
                    key={row}
                    variant="rounded"
                    height={ROW_HEIGHT}
                    sx={{ borderRadius: 1.25, bgcolor: skeletonBg }}
                  />
                ))}
              </Box>
            ))}
          </Box>
          <Skeleton
            variant="rounded"
            height={FOOTER_HEIGHT}
            sx={{ borderRadius: 1.25, bgcolor: skeletonBg, mt: 1.25 }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default CalendarSkeleton;
